import _extends from '../../../node_modules/.pnpm/@babel_runtime@7.24.0/node_modules/@babel/runtime/helpers/esm/extends.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.constructor.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.for.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.key-for.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.json.stringify.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.get-own-property-symbols.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.description.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.function.name.js';
import { __assign } from '../../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React from 'react';
import { TextArea as TextArea$1 } from 'antd-mobile';
import { TiForm } from '../../index.js';
import useLanguage from '../../../hooks/useLangugle/index.js';

var TextArea = function TextArea(props) {
  var name = props.name,
    label = props.label,
    rules = props.rules,
    border = props.border,
    description = props.description,
    subscribe = props.subscribe,
    _a = props.fieldProps,
    fieldProps = _a === void 0 ? {} : _a;
  var disabled = fieldProps.disabled;
  var CommonLocale = useLanguage('Common');
  var style = {
    borderRadius: '4px',
    padding: '8px',
    width: 'auto',
    border: '1px solid #E0E2EC',
    '--font-size': '14px',
    '--placeholder-color': '#9EA1A7'
  };
  return /*#__PURE__*/React.createElement(TiForm.Item, {
    name: name,
    label: label,
    rules: rules,
    direction: "vertical",
    border: border,
    description: description,
    subscribe: subscribe
  }, /*#__PURE__*/React.createElement(TextArea$1, _extends({
    placeholder: CommonLocale['pleaseInput'],
    maxLength: 210,
    rows: 2,
    showCount: true,
    disabled: disabled
  }, fieldProps, {
    style: disabled ? __assign(__assign({}, style), {
      opacity: '0.4',
      cursor: 'not-allowed'
    }) : style
  })));
};

export { TextArea as default };
